import React from 'react'
import type { ComponentTypes } from 'types/selectComponent'
import type { FilterComponentNode, FilterComponentRendererType, FilterGenericPropsType } from '../type'
import CableLengthFilter, { FilterOptionsType } from './CableLengthFilter'

export const CABLE_LENGTH_FILTER_KEY = 'cable_length'

const maybeCreateCableLengthFilterNode = ({
  componentType,
  RendererComponent,
}: {
  componentType?: ComponentTypes
  RendererComponent: FilterComponentRendererType<FilterOptionsType>
}): FilterComponentNode | undefined => {
  if (componentType !== 'other') {
    return
  }

  const FilterComponent = (props: FilterGenericPropsType) => (
    <CableLengthFilter filterKey={CABLE_LENGTH_FILTER_KEY} RendererComponent={RendererComponent} {...props} />
  )

  return {
    key: CABLE_LENGTH_FILTER_KEY,
    component: FilterComponent,
  }
}

export default maybeCreateCableLengthFilterNode
